import React from 'react'

import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import { twMerge } from 'tailwind-merge'

import { Text } from '../../v2/Text'

const CouponInput = ({
  placeholder,
  color,
  status,
  type,
  disabled,
  isLoading,
  defaultValue,
  inputProps,
  onKeyPress,
  height,
  border,
  className,
  ...wrapperProps
}) => {
  const { ref: inputRef, ...restInputProps } = inputProps ?? {}

  return (
    <InputField
      className={twMerge(className)}
      $height={height}
      $border={border}
      isLoading={isLoading}
      disabled={disabled}
      {...wrapperProps}
    >
      <Input
        color='black'
        ref={inputRef}
        disabled={isLoading || disabled}
        type={type}
        placeholder={placeholder}
        defaultValue={defaultValue}
        onKeyPress={onKeyPress}
        {...restInputProps}
      />
      {isLoading ? (
        <Image src='/static/images/match-maker/loader.svg' alt='loading' />
      ) : (
        <Text
          variant='tiny'
          className='absolute right-3'
          style={color ? { color } : undefined}
        >
          {status}
        </Text>
      )}
    </InputField>
  )
}

const InputField = styled.div`
  background-color: ${({ theme: t, disabled }) => (disabled ? t?.colors?.snow : t?.colors?.white)};
  position: relative;
  border: ${({ theme: t, disabled, isLoading, $border }) =>
    $border ? $border : `0.5px solid ${disabled ? t?.colors?.gray?.n200 : isLoading ? t?.colors?.gray?.n200 : t?.colors?.gray?.n300}`};
  height: ${({ $height }) => ($height ? (typeof $height === 'number' ? `${$height}px` : $height) : '48px')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 12px;
  border-radius: 4px;
  width: 100%;
`

const Input = styled.input`
  font-size: 16px;
  width: 100%;
  border: none;
  background-color: transparent;
  &:focus {
    outline: none;
  }
  &::placeholder {
    font-size: 16px;
  }
`

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`

const Image = styled.img`
  width: 20px;
  animation: ${rotate} 2s linear infinite;
`

CouponInput.defaultProps = {
  isLoading: false,
  disabled: false,
  type: 'text'
}

CouponInput.propTypes = {
  disabled: PropTypes.bool,
  inputProps: PropTypes.object,
  isLoading: PropTypes.bool,
  type: PropTypes.string,
  status: PropTypes.string,
  placeholder: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  border: PropTypes.string,
  className: PropTypes.string
}

export { CouponInput }
